import React from 'react';
import clsx from 'clsx';
import CouponsAmountBadge from "../coupons/Lists/components/CuponesAmountBadge";

interface ThemeTab {
    tabId: string | number;
    tabTitle: string;
    newEventsCount?: number | undefined;
}

interface ThemeTabsProps {
    value: number | string;
    handleChange: (newTabId: any) => void;
    tabs: ThemeTab[];
    containerMaxWidth: boolean;
    indicatorStyles?: any;
    rootStyles?: any;
    tabStyles?: any;
}

export function CouponThemeTabs(props: ThemeTabsProps) {
    const onChange = (tabId: string | number) => () => {
        props.handleChange(tabId);
    };
    return (
        <div className="flex w-full rounded-[29px] bg-[#171A1E]  overflow-hidden items-center justify-between p-[2px] gap-[2px]">
            {props.tabs.map(value => (
                <div
                    key={value.tabId}
                    onClick={onChange(value.tabId)}
                    className={clsx(
                        "relative cursor-pointer flex-1 h-[24px] tablet:h-[48px] flex items-center justify-center text-[14px] font-['Roboto'] leading-[100%] desktop:text-[16px]",
                        props.value === value.tabId
                            ? 'bg-[#03A9F4B2] text-white font-medium rounded-[29px]'
                            : 'bg-[#171A1E] text-[#727374]'
                    )}
                >
                    {value.newEventsCount ? (
                        <CouponsAmountBadge
                            active={props.value === value.tabId}
                            amount={value.newEventsCount}
                        >
                            <h5>{value.tabTitle}</h5>
                        </CouponsAmountBadge>
                    ) : (
                        <h5>{value.tabTitle}</h5>
                    )}
                </div>
            ))}
        </div>
    );
}
